const ENCRYPTION_KEY = 'Ks9$mL#pQ7@vX2&zR4*fC6!hN3^yE8'

function xorEncrypt(text: string, key: string): string {
  return text
    .split('')
    .map((char, index) =>
      String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(index % key.length))
    )
    .join('')
}

interface SessionData {
  sessionId: string
  modelId: string
  providerId: string
}

export const storeSessionData = (data: SessionData) => {
  const encryptedData = xorEncrypt(JSON.stringify(data), ENCRYPTION_KEY)
  sessionStorage.setItem('currentSessionData', encryptedData)
}

export const getAndClearSessionId = (): string | null => {
  const encryptedData = sessionStorage.getItem('currentSessionData')
  if (encryptedData) {
    const decryptedData = xorEncrypt(encryptedData, ENCRYPTION_KEY)
    const sessionData: SessionData = JSON.parse(decryptedData)
    return sessionData.sessionId
  }
  return null
}

export const getAndClearModelId = (): string | null => {
  const encryptedData = sessionStorage.getItem('currentSessionData')
  if (encryptedData) {
    const decryptedData = xorEncrypt(encryptedData, ENCRYPTION_KEY)
    const sessionData: SessionData = JSON.parse(decryptedData)
    return sessionData.modelId
  }
  return null
}

export const getAndClearProviderId = (): string | null => {
  const encryptedData = sessionStorage.getItem('currentSessionData')
  if (encryptedData) {
    const decryptedData = xorEncrypt(encryptedData, ENCRYPTION_KEY)
    const sessionData: SessionData = JSON.parse(decryptedData)
    return sessionData.providerId
  }
  return null
}

// Note: The session data is not cleared after retrieval in these functions.
// If you want to clear the session after retrieving, uncomment the following line
// in each function:
// sessionStorage.removeItem('currentSessionData');
